export function getCurrentRow(
  currentPage: number,
  size: number,
  index: number
): number {
  return ((currentPage - 1) * size) + (index + 1)
}